/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { sendInvitations } from './users.invite.thunk';
import {
  selectDialog,
  selectInvitations,
  selectStatus,
  toggleDialog,
  toggleSuccessDialog,
  updateInvitations,
  selectSuccessDialog,
} from './users.invite.slice';
import { fetchInvitations } from '../../invitations/paginate/invitations.thunk';

export default function useInviteUser(orgId) {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const invitations = useSelector(selectInvitations);
  const status = useSelector(selectStatus);
  const dialog = useSelector(selectDialog);
  const successDialog = useSelector(selectSuccessDialog);

  const onUpdateInvitations = (newInvitations) => {
    dispatch(updateInvitations(newInvitations));
  };

  const onToggleDialog = open => dispatch(toggleDialog(open));
  const onToggleSuccessDialog = open => dispatch(toggleSuccessDialog(open));

  useEffect(() => {
    setIsLoading(status === ThunkStatus.LOADING);

    if (status === ThunkStatus.SUCCEEDED) {
      dispatch(
        fetchInvitations({
          organizationId: orgId,
          pagingSortingAndFiltering: {
            filter: [],
            numberOfElementsOnAPage: 10,
            pageNumber: 0,
            sortColumn: null,
            sortOrder: null,
          },
        }),
      );
    }
  }, [status]);

  const onSubmit = () => {
    dispatch(sendInvitations({ orgId, invitations }));
  };

  return {
    invitations,
    isLoading,
    successDialog,
    dialog,
    onSubmit,
    onToggleSuccessDialog,
    onToggleDialog,
    onUpdateInvitations,
  };
}
